import axios from 'axios';
import Auth from './auth';

axios.interceptors.request.use((config) => {
    const token = Auth.getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default axios;
